// test2227
(2227 && 0);
